import { parseUrlParts } from './parseUrl';
/**
 * Converts an ApiConnection to a common Connection.
 * @internal
 */
export function toConnection(connection) {
    const urlParts = parseUrlParts(connection.url);
    return {
        Canned: connection.canned,
        ConnectionUrl: urlParts.connectionUrl,
        DatasourceId: urlParts.datasourceId,
        DefaultTab: connection.defaultTab,
        Description: connection.description,
        Disabled: connection.disabled,
        Id: connection.id,
        LegacyId: connection.legacyId,
        Name: connection.name,
        ProjectId: urlParts.projectId,
        ServerUrl: urlParts.serverUrl,
        Type: connection.type,
        UIUrl: null,
        Url: connection.url,
        WorkAreaName: connection.workAreaName
    };
}
/**
 * Converts a common Connection to an ApiConnection.
 * @internal
 */
export function toApiConnection(Connection) {
    var _a;
    return {
        defaultTab: Connection.DefaultTab,
        description: Connection.Description,
        disabled: Connection.Disabled,
        legacyId: Connection.LegacyId,
        name: Connection.Name,
        url: Connection.Url,
        workAreaName: (_a = Connection.WorkAreaName) !== null && _a !== void 0 ? _a : ''
    };
}
